// config
import * as http from 'utils/http';
import config from 'config';

const cancelTicket = async ({ id, feedBackDTO }) => {
  return http.post(`${config.API_URL}price-negotiation/tickets/${id}/cancellations/`, {
    feedback: { ...feedBackDTO, stars: 0 },
  });
};

export default cancelTicket;
